export const getAccessToken = async (): Promise<string> => {
  return localStorage.getItem("accessToken") || "";
};
